var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarePrioritiesPhysical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 261 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_105_35478",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 147
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.822 144.134C156.362 149.129 189.665 145.812 214.783 136.387C239.881 126.969 256.927 111.398 259.679 91.8162C262.431 72.2343 250.337 52.5681 228.807 36.5972C207.26 20.6134 176.162 8.24528 140.622 3.2504C105.081 -1.74447 71.7787 1.57272 46.6603 10.9981C21.5622 20.4158 4.51589 35.9867 1.76383 55.5685C-0.988218 75.1504 11.1058 94.8167 32.6358 110.788C54.1832 126.771 85.2813 139.139 120.822 144.134Z",
    fill: "#F5F9FE",
    stroke: "#E1E1E1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_105_35478)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_105_35478)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.722,
    cy: 73.6924,
    rx: 129.725,
    ry: 70.6342,
    transform: "rotate(8 130.722 73.6924)",
    fill: "#F5F9FE"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.919,
    cy: 69.1609,
    rx: 49.1918,
    ry: 49.1918,
    fill: "#E1F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9518 172.248C69.9518 172.248 38.4184 134.729 47.8642 125.134C57.31 115.539 73.1861 126.013 70.466 115.313C67.7458 104.613 56.9174 94.2327 61.2877 86.1313C66.5438 76.3833 81.9267 84.2901 89.3749 87.7051C103.222 94.0486 118.557 94.7538 113.252 85.8812C107.947 77.0086 94.0093 68.3375 99.0604 63.2794C105.932 56.3974 143.722 81.8722 159.894 101.841C169.576 113.781 176.631 105.471 175.648 97.8005C175.026 92.9369 168.169 82.8623 175.363 78.3114C182.311 73.9237 198.49 87.5244 203.989 95.9211C218.392 117.911 194.811 172.071 194.811 172.071L69.9518 172.248Z",
    fill: "#C5CEDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4742 108.459C100.21 115.132 98.7338 126.485 90.4622 131.12C85.9363 133.583 80.8574 134.853 75.7047 134.809C61.7809 134.809 50.4939 126.072 50.4939 115.292C50.4939 115.292 47.6452 105.457 58.4841 101.184C69.323 96.9112 61.6107 87.7954 55.6354 79.2494C49.6602 70.7033 50.7927 61.8794 56.49 40.7957C62.1874 19.712 66.7453 13.4484 77.2854 12.8787C87.8255 12.3089 85.5709 36.6269 86.2066 41.8171C87.2141 50.0331 104.918 58.1726 103.208 68.4279C101.499 78.6831 88.9649 93.4928 88.9649 93.4928C88.9649 93.4928 84.1222 97.4809 88.3952 102.893C89.9791 104.845 91.675 106.703 93.4742 108.459Z",
    fill: "#C9DEF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7841 171.571V61.3618",
    stroke: "#658FDF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7842 77.3144C74.7842 77.3144 69.5454 71.8289 68.9409 67.337",
    stroke: "#658FDF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7842 100.878C74.7842 100.878 78.5882 97.8561 79.5922 94.4203",
    stroke: "#658FDF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7842 129.768C74.7842 129.768 69.1424 124.946 68.9409 120.736",
    stroke: "#658FDF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.237 101.82L171.337 171.984",
    stroke: "#824F3F",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.426,
    y: 99.117,
    width: 5.28741,
    height: 4.5544,
    rx: 2.2772,
    transform: "rotate(-4.63 163.426 99.117)",
    fill: "#824F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.184 95.188C165.184 95.188 168.849 97.0293 169.256 99.197C169.662 101.365 169.047 103.487 168.759 103.491C168.471 103.494 168.03 102.925 167.37 101.129C166.709 99.3325 164.938 98.8531 165.563 100.535C166.188 102.216 166.122 102.463 165.737 102.546C165.351 102.629 161.446 99.5027 162.093 98.7558L165.184 95.188Z",
    fill: "#F4B59E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.259 81.2643C155.259 81.2643 154.69 84.9259 165.122 94.2327C165.618 94.6752 165.821 95.3598 165.647 96.001C165.15 97.8248 163.812 101.153 160.915 99.7077C157.007 97.7553 157.351 97.1891 157.351 97.1891",
    fill: "#020C47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.402 43.5992C135.402 43.5992 136.097 40.3233 141.482 39.156C146.866 37.9887 149.784 42.4285 150.25 43.5992C150.715 44.77 151.421 55.6436 148.732 59.8506C146.043 64.0576 140.196 62.3067 140.196 62.3067C140.196 62.3067 136.92 58.6833 136.92 57.5126C136.92 56.3419 137.038 52.7185 137.038 52.7185C137.038 52.7185 135.399 51.975 135.402 49.5919C135.402 49.5919 135.444 48.3169 135.659 48.2718C135.875 48.2266 134.443 47.3129 135.402 43.5992Z",
    fill: "#F3B7B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.189,
    y: 51.718,
    width: 4.89138,
    height: 3.14397,
    rx: 1.57198,
    transform: "rotate(-180 147.189 51.718)",
    stroke: "#DC4D49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.296,
    y: 51.718,
    width: 3.14395,
    height: 3.14397,
    rx: 1.57198,
    transform: "rotate(-180 152.296 51.718)",
    stroke: "#DC4D49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.155 49.6787C148.52 49.4498 147.824 49.4498 147.189 49.6787",
    stroke: "#DC4D49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.891 94.6878C140.891 94.6878 152.942 94.2153 152.911 92.7007C152.879 91.186 158.198 130.689 158.302 133.749C158.407 136.81 161.252 162.757 161.252 162.757C161.252 162.757 161.884 165.144 155.773 166.2C149.662 167.256 150.395 163.456 150.395 163.456C150.395 163.456 145.184 127.09 141.273 118.874L143.128 113.517L140.891 94.6878Z",
    fill: "#658FDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.364 161.42C126.039 147.833 128.197 95.1881 128.197 95.1881C140.356 94.7712 151.149 90.9741 151.149 90.9741L153.07 100.799L150.826 106.652C149.454 110.159 146.791 113.007 143.385 114.611C143.385 114.611 142.732 124.144 142.395 130.526C142.058 136.907 138.66 152.818 138.66 152.818C138.66 152.818 136.312 164.369 134.127 165.849C132.563 166.909 129.228 167.016 125.973 166.384C125.084 166.21 123.851 165.457 123.472 164.647C123.003 163.626 123.152 162.511 123.364 161.42Z",
    fill: "#7AA0DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.298 109.998C131.758 110.422 127.012 108.261 127.36 106.982C127.815 105.308 129.097 96.8348 129.395 89.2962C129.527 85.8222 127.638 75.7476 127.638 75.7476C125.876 67.4517 131.289 62.0184 132.414 60.7365L136.93 57.5265C136.93 57.5265 137.313 58.9161 138.994 60.8997C140.206 62.3206 141.631 62.5985 143.993 62.6367C146.355 62.675 147.867 60.2883 147.867 60.2883L150.743 62.1851C150.743 62.1851 154.353 63.6824 155.176 67.0487C155.871 69.9321 157.979 95.4764 157.997 103.811C157.997 108.229 156.569 108.99 155.249 109.081L142.298 109.998Z",
    fill: "#000B64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.773 54.7751C141.773 54.7751 140.682 55.0808 140.682 52.3433C140.682 49.6058 141.207 46.0901 139.067 44.7005C136.927 43.3109 134.655 41.8206 134.436 44.9194C134.217 48.0182 135.353 48.4142 136.142 48.369C136.931 48.3239 138.848 48.31 138.893 50.8286C138.938 53.3473 139.164 53.8996 139.546 55.2684C141.429 61.9906 146.977 62.9876 148.026 62.6819C149.076 62.3762 150.507 60.7295 150.726 54.8341C150.726 54.8341 150.858 53.8302 148.673 53.7433C146.487 53.6565 143.302 55.0808 141.773 54.7751Z",
    fill: "#555656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.896 57.0471C149.896 57.0471 149.242 56.0848 148.086 56.8282C146.929 57.5716 150.552 58.0163 149.896 57.0471Z",
    fill: "#F3B7B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.844 49.0986C137.844 49.0986 141.075 48.6191 142.298 49.4043",
    stroke: "#DC4D49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.229 100.694C129.229 100.694 132.397 103.102 134.481 102.48C136.566 101.858 138.188 100.35 138.073 100.093C137.959 99.8363 137.267 99.7077 135.405 99.9509C133.543 100.194 132.376 98.8288 134.123 98.6204C135.871 98.4119 136.065 98.2417 135.975 97.863C135.885 97.4844 131.487 95.4312 131.094 96.3553L129.229 100.694Z",
    fill: "#F4B59E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.945 95.2298C131.945 95.2298 133.293 102.782 128.471 101.716C123.649 100.649 116.549 92.996 115.965 90.0118C115.017 85.1274 115.291 80.1491 119.394 74.9625C123.497 69.7758 132.425 60.7191 132.425 60.7191C132.425 60.7191 139.164 62.0809 136.719 69.286C136.507 69.9113 128.836 77.7486 126.512 80.2881C123.681 83.38 123.167 86.6212 125.206 89.5984C127.245 92.5756 131.945 95.2298 131.945 95.2298Z",
    fill: "#000B64"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_105_35478",
    x: 1.87695,
    y: 1.43558,
    width: 257.689,
    height: 147.514,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_105_35478"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_105_35478"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarePrioritiesPhysical);
export default __webpack_public_path__ + "static/media/Care Priorities - Physical.35ee39b4cea25a5436953dd17e3d249f.svg";
export { ForwardRef as ReactComponent };